module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hasNoContent":"Found nothing here"},"no":{"hasNoContent":"Fant ikke noe her"}}')
  delete Component.options._Ctor
}
